import PropTypes from 'prop-types';

export const creatorBrandType = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string,
  logo: PropTypes.string,
});
